import { createContext, useContext, useMemo, FC, createElement } from 'react'
import en from './locales/en_US.json'
import zh from './locales/zh_CN.json'

const LanguageMaps = {
  en,
  zh
}

interface I18nContextProps {
  language: LanguageList
}

type LanguageList = keyof typeof LanguageMaps

export const I18nContext = createContext<I18nContextProps | null>(null)

type I18nextProviderProps  = I18nContextProps

export const I18nextProvider: FC<I18nextProviderProps> = ({ language, children }) => {
  const value = useMemo(
    () => ({
      language,
    }),
    [language]
  )
  return createElement(
    I18nContext.Provider,
    {
      value,
    },
    children
  )
}

export const useTranslation = () => {
  const { language } = useContext(I18nContext) || {}
  return useMemo(() => {
    return {
      t: (field: string) => {
        if (!field || typeof field !== 'string') {
          return
        } else {
          return LanguageMaps[language || 'zh']?.[field]
        }
      },
    }
  }, [language])
}